export default __webpack_public_path__ + "static/media/refresh.b5bbfc50.svg";